<template>
  <div>
    <div style="display: flex; flex-direction: column;justify-content: space-between;  height: 100%;">
      <div>
        <div style="display:flex;justify-content: space-between; align-items: center;">
          <div style="font-size: 18px;font-weight: 700;line-height: 2.2;color: #000000;">{{ title }}</div>
          <div v-if="mode === 'view'" style="display: flex; align-items: center; gap: 8px;">
            <el-tag
              v-if="isRefunded"
              :style="{
                backgroundColor: '#E6A23C',
                borderColor: '#E6A23C',
                color: '#FFFFFF',
                borderRadius: '8px',
              }"
            >
              已退款
            </el-tag>
            <HotelOrderStatusTag :status="status" />
          </div>
        </div>
        <div>
          <el-row
            style="
          padding: 4px 8px;background-color: #E5E7EB;
          font-weight: 300; border: solid 1px #E6E6E6;
          border-top-left-radius: 8px;border-top-right-radius: 8px;"
          >
            <el-col :span="17" style="text-align: left;">項目</el-col>
            <el-col :span="2" style="text-align: center;">數量</el-col>
            <el-col :span="5" style="text-align: right;">小計</el-col>
          </el-row>
          <el-collapse v-model="localActiveNames">
            <el-collapse-item name="1">
              <template slot="title">
                <div style="line-height:2;">
                  <div style="font-size:18px;width:100%;color: #EA6A2A;">{{ summary.roomTitle || '-' }}</div>
                  <div style="font-size:16px;color:#6C6B6B">
                    {{ summary.dateRange || '-' }}
                  </div>
                </div>
              </template>

              <div style="font-size:16px; background-color: #FFFFFF;font-weight: 500;border-radius: 4px;">
                <el-row v-for="(booking, index) in bookings" :key="`${booking.date || 'date'}-${index}`" style="padding: 8px; border-bottom: solid 1px #E6E6E6;">
                  <el-col :span="7" style="text-align: left;">{{ booking.date }} </el-col>
                  <el-col :span="10" style="text-align: left;">{{ booking.roomName }}{{ booking.roomTitle }}</el-col>
                  <el-col :span="2" style="text-align: center;">x{{ booking.quantity }}</el-col>
                  <el-col :span="5" style="text-align: right;">${{ formatNumber(booking.price) }}</el-col>
                </el-row>
              </div>

              <div style="font-size:16px; background-color: #FFFFFF;font-weight: 500;border-radius: 4px;">
                <template v-if="calculateOrder && calculateOrder.extraGuestFee && calculateOrder.extraGuestFee.length > 0">
                  <el-row v-for="extra in calculateOrder.extraGuestFee" style="padding: 8px; border-bottom: solid 1px #E6E6E6;" :style="{ color: extra.price < 0 ? '#ea6a2a' : '' }">
                    <el-col :span="7" style="text-align: left;">{{ formatDate(extra.bookingDate) || '' }}</el-col>
                    <el-col :span="10" style="text-align: left;"
                      >加住一隻 <br />{{ extra.roomTypeTitle || '' }} <span v-if="0 < extra.roomNumber < 10 && extra.roomNumber">0</span>{{ extra.roomNumber || '' }}</el-col
                    >
                    <el-col :span="2" style="text-align: center;">x{{ extra.count }}</el-col>
                    <el-col :span="5" style="text-align: right;"> {{ extra.price > 0 ? `$${formatNumber(extra.price)}` : formatNumber(extra.price) || '' }}</el-col>
                  </el-row>
                </template>
              </div>

              <div style="font-size:16px; background-color: #FFFFFF;font-weight: 500;border-radius: 4px;">
                <template v-if="calculateOrder && calculateOrder.priceRuleAdjustment && calculateOrder.priceRuleAdjustment.length > 0">
                  <el-row v-for="adjustment in calculateOrder.priceRuleAdjustment" style="padding: 8px; border-bottom: solid 1px #E6E6E6;" :style="{ color: adjustment.price < 0 ? '#ea6a2a' : '' }">
                    <el-col :span="7" style="text-align: left;">-</el-col>
                    <el-col :span="10" style="text-align: left;">{{ adjustment.title || '' }}</el-col>
                    <el-col :span="2" style="text-align: center;">x1</el-col>
                    <el-col :span="5" style="text-align: right;"> {{ adjustment.price > 0 ? `$${formatNumber(adjustment.price)}` : formatNumber(adjustment.price) || '' }}</el-col>
                  </el-row>
                </template>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-row style="padding: 8px; border-bottom: solid 1px #E6E6E6;font-size:16px; background-color: #FFFFFF;font-weight: 500;border-radius: 4px; color: #6C6B6B;">
            <el-col :span="17" style="text-align: left;">小計 </el-col>
            <el-col :span="7" style="text-align: right;">${{ formatNumber(subtotal) }}</el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HotelOrderStatusTag from './HotelOrderStatusTag.vue'

export default {
  name: 'FinalOrderListPartial',
  components: {
    HotelOrderStatusTag,
  },
  props: {
    title: {
      type: String,
      default: '訂單計算',
    },
    mode: {
      type: String,
      default: '',
    },
    summary: {
      type: Object,
      default: () => ({}),
    },
    bookings: {
      type: Array,
      default: () => [],
    },
    subtotal: {
      type: Number,
      default: 0,
    },
    status: {
      type: String,
      default: '',
    },
    isRefunded: {
      type: Boolean,
      default: false,
    },
    calculateOrder: {
      type: Object,
      default: () => ({
        priceRuleAdjustment: [],
      }),
    },
    // 控制預設是否展開 ['1'] 展開， [] 收合'
    activeNames: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpenCalculator: false,
      localActiveNames: this.activeNames,
    }
  },
  watch: {
    activeNames(newVal) {
      this.localActiveNames = newVal
    },
  },
  computed: {},
  methods: {
    formatNumber(num) {
      // 會自動加上千位逗號
      const value = Number(num) || 0
      return value.toLocaleString()
    },
    formatDate(dateString) {
      if (!dateString) return ''
      return dateString.replace(/-/g, '/')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-collapse-item__arrow {
  font-size: 26px;
  font-weight: 900;
}
::v-deep .el-collapse-item__header {
  height: auto;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px;
}

::v-deep .el-collapse-item__wrap {
  background-color: #f9f9fb;
}
</style>
